function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonnelEdo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 60 60",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "m0 0h60v60h-60z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m47.5 55h-42.5c-1.3 0-2.6-.5-3.5-1.5-1-.9-1.5-2.2-1.5-3.5v-32.5c0-1.3.5-2.6 1.5-3.5.9-1 2.2-1.5 3.5-1.5h9c1 0 1.9.4 2.7 1.1l4.8 4.8c.2.2.6.4.9.4h25.2c1.3 0 2.6.5 3.5 1.5.9.9 1.5 2.2 1.5 3.5v26.2c0 1.3-.5 2.6-1.5 3.5-1 1-2.3 1.5-3.6 1.5zm-42.5-40c-.7 0-1.3.3-1.8.7-.5.5-.7 1.1-.7 1.8v32.5c0 .7.3 1.3.7 1.8.5.5 1.1.7 1.8.7h42.5c.7 0 1.3-.3 1.8-.7.5-.5.7-1.1.7-1.8v-26.3c0-.7-.3-1.3-.7-1.8-.5-.5-1.1-.7-1.8-.7h-25.2c-1 0-1.9-.4-2.7-1.1l-4.8-4.8c-.2-.2-.5-.3-.8-.3z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m55 47.5h-3.8v-2.5h3.8c.7 0 1.3-.3 1.8-.7.5-.5.7-1.1.7-1.8v-26.3c0-.7-.3-1.3-.7-1.8-.5-.5-1.1-.7-1.8-.7h-25.2c-1 0-1.9-.4-2.7-1.1l-4.8-4.8c-.2-.2-.6-.4-.9-.4h-9c-.7 0-1.3.3-1.8.7-.3.6-.6 1.2-.6 1.9v3.8h-2.5v-3.8c0-1.3.5-2.6 1.5-3.5.9-1 2.2-1.5 3.5-1.5h9c1 0 1.9.4 2.7 1.1l4.8 4.8c.2.2.5.4.9.4h25.1c1.3 0 2.6.5 3.5 1.5.9.9 1.5 2.2 1.5 3.5v26.2c0 1.3-.5 2.6-1.5 3.5-.9 1-2.2 1.5-3.5 1.5z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m30 25h16.3v2.5h-16.3z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m30 31.2h16.3v2.5h-16.3z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m16.3 36.3c-3.4 0-6.3-2.8-6.3-6.3 0-3.4 2.8-6.3 6.3-6.3s6.3 2.8 6.3 6.3c-.1 3.4-2.9 6.3-6.3 6.3zm0-10c-2.1 0-3.7 1.7-3.7 3.7s1.7 3.7 3.7 3.7 3.7-1.6 3.7-3.7-1.7-3.7-3.7-3.7z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m26.3 48.7h-2.5v-4.4c0-.8-.3-1.6-.9-2.2s-1.4-.9-2.2-.9h-8.8c-.8 0-1.6.3-2.2.9s-.9 1.4-.9 2.2v4.4h-2.6v-4.4c0-1.5.6-2.9 1.6-4 1.1-1.1 2.5-1.6 4-1.6h8.8c1.5 0 2.9.6 4 1.6 1.1 1.1 1.6 2.5 1.6 4v4.4z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonnelEdo);
export default __webpack_public_path__ + "static/media/personnel_edo.10d37afee182a140815b740351200f96.svg";
export { ForwardRef as ReactComponent };